const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="m20.445 11.253-7.07-7.071a1.5 1.5 0 0 0-2.122 0l-7.071 7.071a1.5 1.5 0 0 0 0 2.121l7.071 7.071a1.5 1.5 0 0 0 2.121 0l7.071-7.07a1.5 1.5 0 0 0 0-2.122m-6.01-8.132a3 3 0 0 0-4.243 0l-7.07 7.071a3 3 0 0 0 0 4.243l7.07 7.071a3 3 0 0 0 4.243 0l7.071-7.071a3 3 0 0 0 0-4.243z" clip-rule="evenodd"/></svg>';
export {
  a as w
};
